export const receiveDriftProperties = properties => {
  return {
    type: 'RECEIVE_DRIFT_PROPERTIES',
    properties
  }
}

export const receiveCustomProperties = properties => {
  return {
    type: 'RECEIVE_CUSTOM_PROPERTIES',
    properties
  }
}

export const receiveArchivedProperties = properties => {
  return {
    type: 'RECEIVE_ARCHIVED_PROPERTIES',
    properties
  }
}

export const updateProperty = (property, index, location) => {
  return {
    type: 'UPDATE_PROPERTY',
    payload: { property, index, location }
  }
}

export const selectProperty = selectedProp => {
  return {
    type: 'SELECT_PROPERTY',
    selectedProp
  }
}

export const deselectProperty = deselectedProp => {
  return {
    type: 'DESELECT_PROPERTY',
    deselectedProp
  }
}

export const archiveProperty = archivedProp => {
  return {
    type: 'ARCHIVE_PROPERTY',
    archivedProp
  }
}

export const receiveSourcedProperties = properties => {
  return {
    type: 'RECEIVE_SOURCED_PROPERTIES',
    properties
  }
}

export const updateSourcedProperty = (sourcedProp, index) => {
  return {
    type: 'UPDATE_SOURCED_PROPERTY',
    payload: { property: sourcedProp, index }
  }
}

export const receiveNewSidebarConfig = config => {
  return {
    type: 'RECEIVE_NEW_SIDEBAR_CONFIG',
    config
  }
}

export const receiveSalesforceProperties = properties => {
  return {
    type: 'RECEIVE_SALEFORCE_PROPERTIES',
    properties
  }
}
